// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.access-denied {
  width: 100%;
  height: 100vh;
  background: #e2dedb;
  display: flex;
  flex-direction: column; /* 使元素上下排列 */
  justify-content: center; /* 垂直方向居中 */
  align-items: center; /* 水平方向居中 */
}
.access-denied-code {
  width: 4.2rem;
  height: 0.65rem;
  padding: 0.15rem;
  background: #f3eee8;
  border-radius: 0.05rem;
}
.access-denied-code .circle-box {
  display: flex;
}
.access-denied-code .circle-box .circle {
  width: 0.0625rem;
  height: 0.0625rem;
  background: #000;
  border-radius: 50%;
  margin-right: 0.03125rem;
}
.access-denied-code .circle-box .circle-1 {
  background: #b5ada6;
}
.access-denied-code .circle-box .circle-2 {
  background: #c8c1ba;
}
.access-denied-code .circle-box .circle-3 {
  background: #a39e99;
}
.access-denied-code .font-mono {
  font-family: "Poppins", sans-serif;
  font-size: 0.1125rem;
  color: #6b6560;
  margin-top: 0.0625rem;
}
.access-denied-main {
  width: 2.8rem;
  height: 3.475rem;
  padding: 0.2rem;
  background: #f3eee8;
  border-radius: 0.05rem;
  margin-top: 0.1875rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.access-denied-main .animate-bounce {
  font-size: 0.5rem;
  animation: bounce 1.8s infinite;
}
.access-denied-main-title {
  font-size: 0.375rem;
  color: #9c8e83;
  text-align: center;
}
.access-denied-main-text {
  font-size: 0.15rem;
  color: #847971;
  text-align: center;
  margin: 0.125rem 0;
}
.access-denied-main-tip {
  font-size: 0.1125rem;
  color: #a39e99;
  text-align: center;
}

@keyframes type {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-0.125rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/accessDenied/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA,EAAA,YAAA;EACA,uBAAA,EAAA,WAAA;EACA,mBAAA,EAAA,WAAA;AAEF;AADE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAGJ;AAFI;EACE,aAAA;AAIN;AAHM;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;AAKR;AAJQ;EACE,mBAAA;AAMV;AAJQ;EACE,mBAAA;AAMV;AAJQ;EACE,mBAAA;AAMV;AAFI;EACE,kCAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAIN;AADE;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAGJ;AAFI;EACE,iBAAA;EACA,+BAAA;AAIN;AAFI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAIN;AAFI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAIN;AAFI;EACE,oBAAA;EACA,cAAA;EACA,kBAAA;AAIN;;AAAA;EACE;IACE,QAAA;EAGF;EADA;IACE,WAAA;EAGF;AACF;AAAA;EACE;IAEE,wBAAA;EACF;EACA;IACE,gCAAA;EACF;AACF","sourcesContent":[".access-denied {\n  width: 100%;\n  height: 100vh;\n  background: #e2dedb;\n  display: flex;\n  flex-direction: column; /* 使元素上下排列 */\n  justify-content: center; /* 垂直方向居中 */\n  align-items: center; /* 水平方向居中 */\n  &-code {\n    width: 672px;\n    height: 104px;\n    padding: 24px;\n    background: #f3eee8;\n    border-radius: 8px;\n    .circle-box {\n      display: flex;\n      .circle {\n        width: 10px;\n        height: 10px;\n        background: #000;\n        border-radius: 50%;\n        margin-right: 5px;\n        &-1 {\n          background: #b5ada6;\n        }\n        &-2 {\n          background: #c8c1ba;\n        }\n        &-3 {\n          background: #a39e99;\n        }\n      }\n    }\n    .font-mono {\n      font-family: \"Poppins\", sans-serif;\n      font-size: 18px;\n      color: #6b6560;\n      margin-top: 10px;\n    }\n  }\n  &-main {\n    width: 448px;\n    height: 556px;\n    padding: 32px;\n    background: #f3eee8;\n    border-radius: 8px;\n    margin-top: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .animate-bounce {\n      font-size: 80px;\n      animation: bounce 1.8s infinite;\n    }\n    &-title {\n      font-size: 60px;\n      color: #9c8e83;\n      text-align: center;\n    }\n    &-text {\n      font-size: 24px;\n      color: #847971;\n      text-align: center;\n      margin: 20px 0;\n    }\n    &-tip {\n      font-size: 18px;\n      color: #a39e99;\n      text-align: center;\n    }\n  }\n}\n@keyframes type {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n@keyframes bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  75% {\n    transform: translateY(-20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
